<template>
  <div class="align_left">
    <h3>
      <b-icon icon="dash" class="primary_color" aria-hidden="true"></b-icon>
      Informations supplémentaires des parcours
    </h3>
    <div id="live_submenu">
      <b-button v-for="(parcours, index) in list_parcours" :key="index" :class="[parcours.id_parcours === current_parcours ? 'active' : '']" class="inline-submenu-btn with_icon" @click="changeParcours(parcours.id_parcours)">
        <b-icon icon="geo" aria-hidden="true"></b-icon>
        {{ parcours.nom_parcours }}</b-button
      >
    </div>
    <hr />
    <div v-for="(parcours, index) in list_parcours" :key="index">
      <ParcoursContentBuilder :parcours="parcours" v-if="parcours.id_parcours === current_parcours"></ParcoursContentBuilder>
    </div>
    <hr />
  </div>
</template>

<script>
import ParcoursContentBuilder from "@/components/Admin_tab/ParcoursContentBuilder.vue";
export default {
  components: { ParcoursContentBuilder },
  data() {
    return {
      list_parcours: [],
      current_parcours: 0,
    };
  },
  created() {
    this.list_parcours = this.$store.state.admin.extra_parcours_content;
    this.current_parcours = this.list_parcours[0].id_parcours;
  },
  methods: {
    changeParcours(p) {
      this.current_parcours = p;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>